module.exports = __webpack_public_path__ + "static/media/dashboard.6c565eb0.svg";